export const RESET = 'LANGUAGE_UPDATE_RESET'
export const SET_ERROR = 'LANGUAGE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'LANGUAGE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'LANGUAGE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'LANGUAGE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'LANGUAGE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'LANGUAGE_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'LANGUAGE_UPDATE_FILES'



// WEBPACK FOOTER //
// ./src/store/modules/language/update/mutation_types.js